import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Views/Home';
import Services from './Views/Services';
import NotFound from './Views/NotFound';
import About from './Views/About';
import ContactUs from './Views/ContactUs';
import Automation from './Components/Automation';
import Robotic from './Components/Robotic';
import RoboticCards from './Components/RoboticCards';
import Printing from './Views/3D-Printing';
import ourservices from './Components/OurServices1';
import warehouse from './Views/Warehouse';
import precise from './Views/Precise';
import Sheetmetal from './Views/Sheetmetal';
import Scanning from './Views/3D-Scanning';
import DesignAndConsultation from './Views/DesignAndConsultation';
import Products from './Views/Products';
import Career from './Views/Career'

function Routers() {
    return (
      <Routes>  
        <Route path='*' Component={NotFound} />
        <Route path='/' Component={Home} />
        <Route path='/services' Component={Services} />
        <Route path='/about' Component={About} />
     <Route path='/ContactUs' Component={ContactUs} />
<Route path='/Automation' Component={Automation} />
<Route path='/Robotic' Component={Robotic} />
<Route path='RoboticCards' Component={RoboticCards} />
<Route path='/Printing' Component={Printing}/>
<Route path='/ourservices' Component={ourservices} />
<Route path='/Warehouse' Component={warehouse} />
<Route path='/Precise' Component={precise} />
<Route path='/Sheetmetal' Component={Sheetmetal} />
<Route path='/Scanning' Component={Scanning} />
<Route path='/DesignAndConsultation' Component={DesignAndConsultation} />
<Route path='/Products' Component={Products}/>
<Route path='/Career' Component={Career}/>
    </Routes>
    )
}

export default Routers;